/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'M5.6 5.6a1 1 0 0 0 0 1.4l4.3 4.3c.4.4.4 1 0 1.4l-5 5L6.3 19l5.7-5.7 5 5a1 1 0 1 0 1.4-1.5L14 12.7a1 1 0 0 1 0-1.4l5-5L17.7 5 12 10.6l-5-5a1 1 0 0 0-1.4 0Z',
  DEV ? 'CloseIcon' : '',
  '',
  false,
);
